// Live PDF preview of a signing packet. Renders through the same
// renderPacketBlob() that produces the filed PDF, so the preview can never
// differ from the final document. Re-renders (debounced) whenever the packet,
// forms, slots or client change.

import React, { useEffect, useRef, useState } from 'react';
import { renderPacketBlob, renderPacketBlobFromData } from '../../lib/documents/generatePacketPdf';

export default function PacketPdfFrame({ packet, client, forms, slots, tokens, files, packetType, data, height = '100%', style, page }) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState('');
  const seq = useRef(0);

  useEffect(() => {
    const mine = ++seq.current;
    setBusy(true); setErr('');
    const t = setTimeout(async () => {
      try {
        const blob = data
          ? await renderPacketBlobFromData(packetType, data)
          : await renderPacketBlob({ packet, client, forms, slots, tokens, files });
        if (mine !== seq.current) return;
        const next = URL.createObjectURL(blob);
        setUrl((prev) => { if (prev) URL.revokeObjectURL(prev); return next; });
      } catch (e) {
        if (mine === seq.current) setErr(e.message || String(e));
      } finally {
        if (mine === seq.current) setBusy(false);
      }
    }, 500);
    return () => clearTimeout(t);
  }, [packet, client, forms, slots, tokens, files, packetType, data]);

  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  return (
    <div style={{ position: 'relative', height, ...style }}>
      {url && (
        <iframe title="Packet preview" src={`${url}#${page ? `page=${page}&` : ''}view=FitH`}
          style={{ width: '100%', height: '100%', border: '1px solid var(--border2)', borderRadius: 8, background: '#fff' }} />
      )}
      {(busy || err) && (
        <div style={{ position: 'absolute', top: 8, left: 8, right: 8, padding: '6px 10px', borderRadius: 6, fontSize: 12,
          background: err ? 'var(--danger-bg)' : 'var(--bg2)', color: err ? 'var(--danger)' : 'var(--text3)', border: '1px solid var(--border)' }}>
          {err ? `Preview failed: ${err}` : 'Rendering document…'}
        </div>
      )}
    </div>
  );
}
